<div class="inline-question-container danger-border p-4 d-flex flex-column">
  <div [innerHTML]="'END_LAB' | translate"></div>
  <hr class="w-100">
  <div class="d-flex justify-content-end">
    <teams-button [classList]="'btn ts-btn-fluent-primary mr-3'"
      *ngIf="showMarkComplete"
      [index]="'markComplete'" [processingTitle]="btnLoadingService.getButtonText()" [showLoading]="showButtonLoading"
      (buttonClick)="markAsComplete()" [title]="'MARK_COMPLETE' | translate"></teams-button>
    <teams-button [classList]="'btn btn-danger ts-btn-fluent-red'" [title]="'END_LAB_BUTTON' | translate"
      (buttonClick)="actionClick('DEALLOCATE')" [showLoading]="" [index]=""></teams-button>
  </div>
</div>